import * as z from 'zod';
import { EntityId } from './base-schemas';
/**
 * Edit history as EditingRecord::buildTimeline() on the server sends it: per date, changes grouped by
 * when and by whom. Shaped so EditingRecordTimeline can render it.
 */
export const EditingRecordTimeline = z.array(z.object({
    date: z.string(),
    editing_record_groups: z.array(z.object({
        time: z.string(),
        source: z.enum(['user', 'guest', 'system']),
        // Null when the change was not made by a logged-in user
        user: z.object({
            id: EntityId,
            name: z.string(),
            is_support: z.boolean()
        }).nullable(),
        editing_records: z.array(z.object({
            id: EntityId,
            // HTML
            description: z.string(),
            // What the change is about when the history combines several things, e.g. the reservations in a reservation order
            subject: z.string().optional()
        }))
    }))
}));
